import { WeddingUsers } from "../../types/user";
import { generateAPI } from "../api.generator";

export const getWeddingUsers = generateAPI<{}, WeddingUsers>(
  "get",
  "user/wedding/users",
);
